import React from "react";
import "../template-file-css/document-file-template.css";

export const GENERAL_AdultIntake = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='GENERAL_AdultIntake' className='file-pdf-document'>
            <div className='file-template'>

                <p className='W-750'>
                    <h3>CLIENT RIGHTS AND RESPONSIBILITIES </h3>
                </p>
                <p className='w-750'>
                    <ol>
                        <li>The right to a humane treatment or habilitation environment that affords reasonable protection from harm, exploitation, and coercion.
                        </li>
                        <li>The right to participate in providing input to your program and an individualized care plan specific to your strengths, needs, abilities, and preferences.
                        </li>
                        <li>The right to have access to their own client records and to obtain necessary copies when needed.
                        </li>
                        <li>The right to refuse services, unless a physician or licensed professional feels that refusal is not in your best interest due to yours or another's safety.
                        </li>
                        <li>The right to converse privately, have convenient and reasonable access to the telephone and mails, and to see visitors, unless denial is necessary for treatment and the reasons are documented in the treatment plan.
                        </li>
                        <li>The right to prompt and confidential services regardless of your funding source.
                        </li>
                        <li>The right to be fully informed of the charges for treatment.
                        </li>
                        <li>The right to receive information in a language you understand and to ask questions and obtain answers about any information for which you need clarification.
                        </li>
                        <li>The right to remain free of physical restraints or time-out procedures unless such measures are required for providing effective treatment or protecting the safety of you or another.
                        </li>
                        <li>The right to be free from any type of abuse, verbal, emotional, physical, financial, or sexual; to be free from neglect, humiliation or retaliation.
                        </li>
                        <li>The right to cancel an appointment with the understanding it is my responsibility to reschedule.
                        </li>
                        <li>The right to be promptly informed of any changes, benefits, or risks in the plan of treatment in sufficient time to make decisions regarding my treatment or services.
                        </li>
                        <li>The right to terminate treatment voluntarily or to be terminated prior to my discharge date for violation of the expectations, treatment, or responsibilities.
                        </li>
                        <li>The right to know names and titles of all those involved in treatment and service planning and implementation.
                        </li>
                        <li>The right to refuse psychotropic medication recommendations.
                        </li>
                        <li>The right to have and retain personal property which does not jeopardize the safety of the client or other clients or staff and have such property treated with respect.
                        </li>
                        <li>The right to file a complaint or to present a grievance to the <input type='text' id='txtProviderName_1' name='txtProviderName_1' className='add-only w-200 custom-add-only' /> Compliance Officer without fear of retaliation, including but not limited to service termination, if you feel any of your rights have been violated.
                        </li>
                        <li>The right to receive a written notice of the address and telephone number of that state licensing authority.
                        </li>
                    </ol>
                </p>
                <h3>CLIENT CONSENT FOR SERVICES
                </h3>
                <p className='w-750'>
                    I am requesting services from  <input type='text' id='txtProviderName_2' name='txtProviderName_2' className='add-only w-200 custom-add-only' />  for the above named Client. I apply for and consent to CORE services.
                </p>
                <p className='w-750'>
                    I understand the treatment teams in CORE consist of a mental health professional, a master's level therapist, in addition to clinical support staff. Once admitted to the program, the client's status and progress will be reviewed every seven (7) days. Report(s) concerning the staff's findings will be available to probation court, social services, and/or the client, upon request. The Client (if 18 years of age or older) will sign a release of information form before any information can be released.
                </p>
                <p className='w-750'>
                    An Individualized Treatment Plan will be developed which contains goals and desired outcomes that can be expected to be achieved in order to be able to move to less intensive community support services. I have had input to these goals and agree to work towards the goals and objectives as established in the treatment plan.
                </p>
                <p className='w-750'>
                    Benefits of services may include improved behavior, improved family cohesion and communication, and acquisition of healthy coping skills. I understand the risks any time an individual or family participates in counseling may include disclosure of information that may have not been previously discussed and feelings surfacing that have not been previously expressed which might be stressful. I understand counseling can provide skills to help me understand and cope with these feelings, make healthier decisions and feel better emotionally.
                </p>
                <p className='w-750'>
                    I can receive concurrent services while receiving services at  <input type='text' id='txtProviderName_3' name='txtProviderName_3' className='add-only w-200 custom-add-only' />, but I agree to let my therapist and/or other treatment team know so that duplication of services does not occur.
                </p>
                <p className='w-750'>
                    I understand the client must have active Medicaid, PeachState, or one of their managed care plans to participate in the Core program. I agree to provide accurate and complete information to  <input type='text' id='txtProviderName_4' name='txtProviderName_4' className='add-only w-200 custom-add-only' />  for billing of the client's treatment and agree to update this information as changes occur. I understand that I will not receive a bill from  <input type='text' id='txtProviderName_5' name='txtProviderName_5' className='add-only w-200 custom-add-only' />, Medicaid or PeachState. However, I consent to allow  <input type='text' id='txtProviderName_6' name='txtProviderName_6' className='add-only w-200 custom-add-only' />  to bill Medicaid, PeachState or one of their managed care organizations (MCOs) for services provided to the client. I authorize exchange of any information between  <input type='text' id='txtProviderName_7' name='txtProviderName_7' className='add-only w-200 custom-add-only' />  and Medicaid, PeachState or one of their managed care organizations for the purpose of providing accurate, thorough and quality services.
                </p>
                <h3>Expectation of Client and Families Participating in Services
                </h3>
                <p className='w-750'>
                    Services provide by  <input type='text' id='txtProviderName_8' name='txtProviderName_8' className='add-only w-200 custom-add-only' />  are designed to meet the needs of clients and their families. CORE services are intended to be a program for both the client and the family that requires a commitment to services and full participation from the client. As a participant of CORE services, you will be required to interact and participate with several team members. The client, and possibly other family members, may be transitioned to supportive, less intensive community service programs when indicated. The treatment team will work with you to assure you are receiving the level of service to meet your needs. Interactions with those providing services may include direct service or referrals for:
                </p>
                <p className='w-750'>
                    <ol>
                        <li>Team approach to counseling
                        </li>
                        <li>Intensive Case Management services to meet the needs of the client
                        </li>
                        <li>Individual Skills Training
                        </li>
                        <li>Family Therapy
                        </li>
                        <li>Individual Counseling
                        </li>
                        <li>Psychological Evaluation and/or Psychiatric Evaluation for the client
                        </li>
                        <li>In home interventions on an as needed basis
                        </li>
                        <li>Crisis Intervention Services
                        </li>
                        <li>Substance Abuse Counseling, as needed
                        </li>
                    </ol>

                </p>
                <p className='w-750'>
                    Note: There is a three (3) strikes policy. We want to empower clients and families to participate in treatment and encourage responsibility as part of emotional health. We understand cancellations and emergencies do occur. However, we want the client and/or their families to call to cancel appointments, to be home during scheduled appointments, and to maintain appointments with psychologist/psychiatrist. If there have been three occurrences of noncompliance, this may lead to early discharge from  <input type='text' id='txtProviderName_9' name='txtProviderName_9' className='add-only w-200 custom-add-only' />.
                </p>
                <p className='w-750'>
                    <h3>Notice of Privacy Practices
                    </h3>

                </p>
                <p className='w-750'>
                    THIS NOTICE DESCRIBES HOW MEDICAL INFORMATION ABOUT YOU MAY BE USED AND DISCLOSED BY THE DEPARTMENT AND HOW YOU CAN GET ACCESS TO THIS INFORMATION. PLEASE REVIEW IT CAREFULLY. This notice is effective April 14, 2003. It is provided to you pursuant to provisions of the Health Insurance Portability and Accountability Act (HIPAA) of 1996 and related federal regulations. If you have questions about this Notice, please contact the  <input type='text' id='txtProviderName_10' name='txtProviderName_10' className='add-only w-200 custom-add-only' />  Compliance Officer at the address below.
                </p>
                <p className='w-750'>
                    This Notice of Privacy Practices describes how  <input type='text' id='txtProviderName_11' name='txtProviderName_11' className='add-only w-200 custom-add-only' />  may use and disclose your protected health information for treatment, payment, health care operations and for certain other purposes. This Notice also describes your rights to access and control your protected health information and provides information about your right to make a complaint if you believe  <input type='text' id='txtProviderName_12' name='txtProviderName_12' className='add-only w-200 custom-add-only' />  has improperly used or disclosed your "protected health information (PHI)." PHI is information that may personally identify you and relates to your past, present or future physical or mental health or condition and related health care services. The organization is required to abide by the terms of this Notice of Privacy Practices and may change the terms of this notice at any time. A new Notice will be effective for all protected health information that the organization maintains at the time of issuance. Upon request, the organization will provide you with a revised Notice of Privacy Practices by posting copies at the organization's main office, in response to a telephone or facsimile request to the  <input type='text' id='txtProviderName_13' name='txtProviderName_13' className='add-only w-200 custom-add-only' />  Compliance Officer, or in person by requesting a copy from your team leader.
                </p>
                <p className='w-750'>
                    <strong>1. Uses and Disclosures of Protected Health Information</strong> Your PHI may be used and disclosed by  <input type='text' id='txtProviderName_14' name='txtProviderName_14' className='add-only w-200 custom-add-only' />, its administrative and clinical staff and others involved in your care and treatment for the purpose of providing health care services to you, and to assist in obtaining payment of your health care bills.
                </p>
                <p className='w-750'>
                    <strong>a. Treatment:</strong> Your PHI may be used to provide, coordinate, or manage your health care and any related services, including coordination of your health care with a third party that has your permission to have access to your PHI, such as, for example, a health care professional who may be treating you, or to another health care provider, such as a psychiatrist or psychologist.
                </p>
                <p className='w-750'>
                    <strong>b. Payment: </strong> Your PHI may be used to obtain payment for your health care services. For example, this may include activities that a health insurance plan requires before it approves or pays for health care services such as: making a determination of eligibility or coverage, reviewing services provided to you for medical necessity, and undertaking utilization review activities.
                </p>
                <p className='w-750'>
                    <strong>c. Health Care Operations:</strong>  <input type='text' id='txtProviderName_15' name='txtProviderName_15' className='add-only w-200 custom-add-only' />  may use or disclose your PHI to support the business activities of the organization, including, for example, but not limited to, quality assessment activities, employee review activities, training, licensing, and other business activities. Your PHI may be used to contact you about appointments or for operational reasons. Your PHI may be shared with third party "business associates," who perform various activities that assist us in the provision of your services.
                </p>
                <p className='w-750'>
                    <strong>2. Other Permitted or Required Uses and Disclosures with Your Authorization or Opportunity to Object</strong>  Other uses and disclosures of your PHI will be made only with your written authorization, which you may revoke at any time, except as permitted or required by law as described below. Generally, if there is PHI which identifies you as a person who has applied for or received substance abuse services, that information will not be disclosed without your consent unless the law allows or requires such a disclosure. The organization may use and disclose your PHI when you authorize in writing such use or disclosure of all or part of your PHI. If you are hospitalized, the organization may use and disclose certain PHI to your representative, as that term is defined in the Georgia Mental Health Code, upon your admission or discharge; you may be given a chance to object to certain other disclosures to your representative.
                </p>
                <p className='w-750'>
                    <strong>3. Permitted or Required Uses and Disclosures without Your Authorization or opportunity to Object</strong>  The organization may use or disclose your PHI without your authorization for continuity of your care or for your treatment in an emergency or when clinically required; when required to do so by law; such as threat of harm to self or others, for public health purposes; to a person who may be at risk of contracting a communicable disease; to a health oversight agency; to an authority authorized to receive reports of abuse or neglect; in certain legal proceedings; and for certain law enforcement purposes. PHI may also be disclosed without your authorization to a coroner or medical examiner, and to the legal representative of your estate.
                </p>
                <p className='w-750'>
                    <strong>4. Required Uses and Disclosures:</strong>  Under the law,  <input type='text' id='txtProviderName_16' name='txtProviderName_16' className='add-only w-200 custom-add-only' />  must make disclosures to you and when required by the Secretary of the Department of Health and Human Services to investigate or determine the organization's compliance with the requirement of the Compliance Rule at 45 CFR Sections 164.500 et. Seq.
                </p>
                <p className='w-750'>
                    <strong>5. Your Rights</strong>  The following is a statement of your rights with respect to your PHI and a brief description of how you may exercise your rights.
                </p>
                <p className='w-750'>
                    <strong>a. You have the right to inspect and copy your protected health information.</strong>  You may inspect and obtain a copy of your PHI about you as long as the organization maintains the protected health information. This information includes medical and billing records and other records the organization uses for making medical and other decisions about you. A reasonable, cost-based fee for copying, postage and other labor expense may apply. Under federal law you may not inspect or copy psychotherapy notes; information compiled in anticipation of, or for use in a civil criminal, or administrative proceeding, or PHI that is subject to a federal or state law prohibiting access to such information.
                </p>
                <p className='w-750'>
                    <strong>b. You have the right to request restriction of your protected health information.</strong>  You may ask the Department not to use or disclose any part of your PHI for the purpose of treatment, payment or health care operations and not to disclose PHI to family members or friends who may be involved in your care. Such a request must state the specific restriction you request, and if the organization believes it is in your best interest to permit use and disclosure of your PHI, your PHI will not be restricted, except as required by law. If the Department does agree to the requested restriction, the organization may not use or disclose your PHI violation of that restriction unless it is needed to provide emergency treatment.
                </p>
                <p className='w-750'>
                    <strong>c. You have the right to request to receive confidential communications from us by alternative means or at an alternative location.</strong>  Upon written request to the person listed in Section 6 below, the organization will accommodate requests for alternative means for the communication of confidential information but may condition this accommodation upon your provision of an alternative address or other method of contact. The organization will not request an explanation form you as the basis for the request.
                </p>
                <p className='w-750'>
                    <strong>d. You may have the right to request an amendment of your protected health information.</strong>  If the organization created your PHI, you may request an amendment of that information for as long as it is maintained by the organization. The organization may deny your request for an amendment, and if it does so will provide information as to any further rights you may have with respect to such denial. Please contact the organization's Compliance Officer at the number listed in Section 6 below if you have questions about amending your medical information.
                </p>
                <p className='w-750'>
                    <strong>e. You have the right to receive an accounting of certain disclosures the organization has made of your protected health information.</strong>  This right applies only to disclosures for the purpose other than treatment, payment or health care operations, excluding any disclosures the organization has made to you, to family members or friends involved in your care, or for national security, intelligence or notification purposes.
                </p>
                <p className='w-750'>
                    You have the right to receive legally specified information regarding disclosures occurring after April 14, 2003, subject to certain exceptions, restrictions and limitations.
                </p>
                <p className='w-750'>
                    <strong>You have the right to obtain a paper copy of this Notice from the organization upon request.</strong>
                </p>
                <p className='w-750'>
                    <strong>6. Complaints.</strong> You may file a complaint in writing with the Compliance Officer at  <input type='text' id='txtProviderName_17' name='txtProviderName_17' className='add-only w-200 custom-add-only' />  at 5680 Fulton Industrial Blvd, Atlanta, Georgia 30336 or by calling 404-346-3471, facsimile 404-346-3473. You must state the basis for the complaint. You may also contact the State of Georgia, Department of Health and Human Services Compliance Coordinator by calling 404-6576423, facsimile 404-657-6424, or by mail to 2 Peachtree Street NW, Room 22.240, Atlanta, Georgia 30303-3142, for further information about the complaint process or this notice. There will be no retaliation against you for filing a complaint.
                </p>
                <h3>Service Plan Individualized Resiliency/Recovery Plan
                </h3>
                <p className='w-750'>
                    I acknowledge that the above name client has participated in the development of my resiliency goals and outcomes and have partnered with  <input type='text' id='txtProviderName_18' name='txtProviderName_18' className='add-only w-200 custom-add-only' />, LLC in the development of these goals based on my choices, preferences, and desired outcomes.
                </p>
                <p className='w-750'>
                    <h3>MEDICAL HISTORY (Completed by Client)
                    </h3>

                </p>
                <p className='w-750'>
                    <h4>Section I </h4>

                </p>
                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Height:</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Weight:</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Age:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtHeight" name="txtHeight" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtWeight" name="txtWeight" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtAge" name="txtAge" className="add-only" />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className="w-650">
                            <span className="eleHeader">Place a check mark under YES or NO for each medical condition
                            </span>
                        </td>
                        <td className="w-50 text-center">
                            <span className="eleHeader">YES</span>
                        </td>
                        <td className="w-50 text-center">
                            <span className="eleHeader">NO</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">If female, are you pregnant?
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant_1" name="rbPregnant" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant_2" name="rbPregnant" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">A disorder of the eyes, nose, or throat
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant1_1" name="rbPregnant1" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant1_2" name="rbPregnant1" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Dizziness, fainting, headache, seizure, convulsions, stroke, head trauma (with or without loss of consciousness) or other neurological disease
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant2_1" name="rbPregnant2" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant2_2" name="rbPregnant2" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Persistent coughing, bronchitis, asthma, emphysema, tuberculosis, or other disorder of the lungs
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant3_1" name="rbPregnant3" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant3_2" name="rbPregnant3" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Chest pain, high blood pressure, rheumatic fever, murmur, heart attack, or other disorder of the heart or blood vessels
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant4_1" name="rbPregnant4" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant4_2" name="rbPregnant4" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Intestinal bleeding, ulcer, hernia, colitis, or other disorder of the stomach, intestines, liver (i.e. hepatitis), or gall bladder
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant5_1" name="rbPregnant5" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant5_2" name="rbPregnant5" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Disorder of kidney, bladder, prostate, or reproductive system including HIV or other sexual transmitted diseases
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant6_1" name="rbPregnant6" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant6_2" name="rbPregnant6" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Diabetes, thyroid, or other endocrine disorders
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant7_1" name="rbPregnant7" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant7_2" name="rbPregnant7" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Arthritis, or other disorder of the muscles, bones, including spine, back or joints
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant8_1" name="rbPregnant8" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant8_2" name="rbPregnant8" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">If sexually active, do you use condoms and/or a means of birth control
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant9_1" name="rbPregnant9" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbPregnant9_2" name="rbPregnant9" className="add-only" value="2" />
                        </td>
                    </tr>
                </table>
                <h4>Section II List all allergies
                </h4>
                <table>
                    <tr>
                        <td className="w-200">
                            <span className="eleHeader">Medication</span>
                        </td>
                        <td className="w-200">
                            <span className="eleHeader">Substance</span>
                        </td>
                        <td className="w-175">
                            <span className="eleHeader">Insects</span>
                        </td>
                        <td className="w-175">
                            <span className="eleHeader">Food</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtMedication" name="txtMedication" className="add-only" />
                        </td>
                        <td className="w-200">
                            <input type="text" id="txtSubstance" name="txtSubstance" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="text" id="txtInsects" name="txtInsects" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="text" id="txtFood" name="txtFood" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtMedication1" name="txtMedication1" className="add-only" />
                        </td>
                        <td className="w-200">
                            <input type="text" id="txtSubstance1" name="txtSubstance1" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="text" id="txtInsects1" name="txtInsects1" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="text" id="txtFood1" name="txtFood1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtMedication2" name="txtMedication2" className="add-only" />
                        </td>
                        <td className="w-200">
                            <input type="text" id="txtSubstance2" name="txtSubstance2" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="text" id="txtInsects2" name="txtInsects2" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="text" id="txtFood2" name="txtFood2" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h4>Section III
                </h4>
                <table>
                    <tr>
                        <td className="w-650">
                            <span className="eleHeader">Place a check mark under YES or NO for each symptom that occurs frequently
                            </span>
                        </td>
                        <td className="w-50">
                            <span className="eleHeader">YES</span>
                        </td>
                        <td className="w-50">
                            <span className="eleHeader">NO</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Headaches
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection_1" name="rbSection" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection_2" name="rbSection" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Hoarse throat
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection1_1" name="rbSection1" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection1_2" name="rbSection1" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Ear infections or pain
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection2_1" name="rbSection2" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection2_2" name="rbSection2" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Fainting spells
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection3_1" name="rbSection3" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection3_2" name="rbSection3" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Balancing problems
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection4_1" name="rbSection4" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection4_2" name="rbSection4" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Breathing problems/cough
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection5_1" name="rbSection5" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection5_2" name="rbSection5" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Difficult or painful urination
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection6_1" name="rbSection6" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection6_2" name="rbSection6" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Menstrual pain
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection7_1" name="rbSection7" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection7_2" name="rbSection7" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Abdominal pain
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection8_1" name="rbSection8" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection8_2" name="rbSection8" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Nausea/vomiting
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection9_1" name="rbSection9" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection9_2" name="rbSection9" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Fevers
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection11_1" name="rbSection11" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection11_2" name="rbSection11" className="add-only" value="2" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-650">Chest pain
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection12_1" name="rbSection12" className="add-only" value="1" />
                        </td>
                        <td className="w-50 text-center">
                            <input type="radio" id="rbSection12_2" name="rbSection12" className="add-only" value="2" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className="eleHeader">Explain any YES answers</span>
                    <textarea id="txtExplain" name="txtExplain" className="formTextarea dd"></textarea>
                </p>
                <table>
                    <tr>
                        <td className="w-200">
                            <span className="eleHeader">Physician Name:</span>
                        </td>
                        <td className="w-200">
                            <span className="eleHeader">Address:</span>
                        </td>
                        <td className="w-175">
                            <span className="eleHeader">Telephone:</span>
                        </td>
                        <td className="w-175">
                            <span className="eleHeader">Date of Last Exam</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-200">
                            <input type="text" id="txtPhysicianName" name="txtPhysicianName" className="add-only" />
                        </td>
                        <td className="w-200">
                            <input type="text" id="txtAddress" name="txtAddress" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="text" id="txtTelephone" name="txtTelephone" className="add-only" />
                        </td>
                        <td className="w-175">
                            <input type="date" id="txtLastExam" name="txtLastExam" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h3>Unified Crisis/Safety Plan
                </h3>
                <h4>Natural Supports and Agencies Involved
                </h4>
                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Name</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Contact Name and Title</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Phone number</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtName" name="txtName" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtContactName" name="txtContactName" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtPhone" name="txtPhone" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtName1" name="txtName1" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtContactName1" name="txtContactName1" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtPhone1" name="txtPhone1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            <input type="text" id="txtName2" name="txtName2" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtContactName2" name="txtContactName2" className="add-only" />
                        </td>
                        <td className="w-250">
                            <input type="text" id="txtPhone2" name="txtPhone2" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h4>Crisis/Safety Plan </h4>


                <table>
                    <tr>
                        <td className="w-250">
                            <span className="eleHeader">Crisis Triggers</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Describe Needed Response</span>
                        </td>
                        <td className="w-250">
                            <span className="eleHeader">Responsible Person/s </span><span className="small block">(name/phone)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">Home
                        </td>
                        <td className="w-250">Client's Response
                        </td>
                        <td className="w-250">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            1.<input type="text" id="txtCrisisTriggers" name="txtCrisisTriggers" className="add-only" />
                        </td>
                        <td className="w-250">
                            1.<input type="text" id="txtDescribeNeeded" name="txtDescribeNeeded" className="add-only" />
                        </td>
                        <td className="w-250">
                            1.<input type="text" id="txtResponsiblePerson" name="txtResponsiblePerson" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            2.<input type="text" id="txtCrisisTriggers1" name="txtCrisisTriggers1" className="add-only" />
                        </td>
                        <td className="w-250">
                            2.<input type="text" id="txtDescribeNeeded1" name="txtDescribeNeeded1" className="add-only" />
                        </td>
                        <td className="w-250">
                            2.<input type="text" id="txtResponsiblePerson1" name="txtResponsiblePerson1" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250"
                        >3.<input type="text" id="txtCrisisTriggers2" name="txtCrisisTriggers2" className="add-only" />
                        </td>
                        <td className="w-250">
                            3.<input type="text" id="txtDescribeNeeded2" name="txtDescribeNeeded2" className="add-only" />
                        </td>
                        <td className="w-250">
                            3.<input type="text" id="txtResponsiblePerson2" name="txtResponsiblePerson2" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">Community
                        </td>
                        <td className="w-250">Client's Response
                        </td>
                        <td className="w-250">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            1.<input type="text" id="txtCrisisTriggers3" name="txtCrisisTriggers3" className="add-only" />
                        </td>
                        <td className="w-250">
                            1.<input type="text" id="txtDescribeNeeded3" name="txtDescribeNeeded3" className="add-only" />
                        </td>
                        <td className="w-250">
                            1.<input type="text" id="txtResponsiblePerson3" name="txtResponsiblePerson3" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">2.
                            <input type="text" id="txtCrisisTriggers4" name="txtCrisisTriggers4" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtDescribeNeeded4" name="txtDescribeNeeded4" className="add-only" />
                        </td>
                        <td className="w-250">2.<input type="text" id="txtResponsiblePerson4" name="txtResponsiblePerson4" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            3.<input type="text" id="txtCrisisTriggers5" name="txtCrisisTriggers5" className="add-only" />
                        </td>
                        <td className="w-250">
                            3.<input type="text" id="txtDescribeNeeded5" name="txtDescribeNeeded5" className="add-only" />
                        </td>
                        <td className="w-250">
                            3.<input type="text" id="txtResponsiblePerson5" name="txtResponsiblePerson5" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">Other
                        </td>
                        <td className="w-250">Client's Response
                        </td>
                        <td className="w-250">&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            1.<input type="text" id="txtCrisisTriggers6" name="txtCrisisTriggers6" className="add-only" />
                        </td>
                        <td className="w-250">
                            1.<input type="text" id="txtDescribeNeeded6" name="txtDescribeNeeded6" className="add-only" />
                        </td>
                        <td className="w-250">
                            1.<input type="text" id="txtResponsiblePerson6" name="txtResponsiblePerson6" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            2.<input type="text" id="txtCrisisTriggers7" name="txtCrisisTriggers7" className="add-only" />
                        </td>
                        <td className="w-250">
                            2.<input type="text" id="txtDescribeNeeded7" name="txtDescribeNeeded7" className="add-only" />
                        </td>
                        <td className="w-250">
                            2.<input type="text" id="txtResponsiblePerson7" name="txtResponsiblePerson7" className="add-only" />
                        </td>
                    </tr>
                    <tr>
                        <td className="w-250">
                            3.<input type="text" id="txtCrisisTriggers8" name="txtCrisisTriggers8" className="add-only" />
                        </td>
                        <td className="w-250">
                            3.<input type="text" id="txtDescribeNeeded8" name="txtDescribeNeeded8" className="add-only" />
                        </td>
                        <td className="w-250">
                            3.<input type="text" id="txtResponsiblePerson8" name="txtResponsiblePerson8" className="add-only" />
                        </td>
                    </tr>
                </table>
                <h3>Crisis/Safety Plan Agreement
                </h3>
                <p className='w-750'>
                    I &nbsp;
                    <input type="text" id="txtSafetyPlan" name="txtSafetyPlan" className="add-only" /> &nbsp;have participated in the development of my crisis/safety plan and I have partnered with  <input type='text' id='txtProviderName_19' name='txtProviderName_19' className='add-only w-200 custom-add-only' />  in the development of these crisis/safety plan on my choices, preferences, and desired outcomes.
                </p>
                <table>
                    <tr>
                        <td className="w-200 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                        <td className="w-150 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-200 small"> Client Signature</td>
                        <td className="w-150 small"> Date</td>
                        <td className="w-250 small"> Clinic Staff</td>
                        <td className="w-150 small"> Date</td>
                    </tr>
                </table>
                <h3>Acknowledgement of Receipt Form
                    <br />
                    Client HandBook
                </h3>
                <p className='w-750'>
                    I acknowledge that I have received a copy of the Client Handbook, which covers the following topics:
                </p>
                <ol>
                    <li>Clients Rights and Responsibilities
                    </li>
                    <li>Client Consent for Services
                    </li>
                    <li>Expectation of Client and Families Participating in Services
                    </li>
                    <li>Notice of Privacy Practices
                    </li>
                    <li>Service Plan
                    </li>
                    <li>Medical History
                    </li>
                </ol>
                <p className='w-750'>
                    If I need any assistance to read and understand this information, I may request accommodation of assistance at any time. Any questions or concerns that I may have will be addressed with the Assessor.
                </p>
                <table>
                    <tr>
                        <td className="w-500 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-500 small">Client Name</td>
                        <td className="w-250 small">Client D.O.B</td>
                    </tr>
                    <tr>
                        <td className="w-500 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-500 small">Client Signature</td>
                        <td className="w-250 small">Date</td>
                    </tr>
                    <tr>
                        <td className="w-500 signature">&nbsp;</td>
                        <td className="w-250 signature">&nbsp;</td>
                    </tr>
                    <tr>
                        <td className="w-500 small">Staff Signature</td>
                        <td className="w-250 small">Date</td>
                    </tr>
                </table>
            </div>
        </form>
    )
}